/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreatePromotionLeadForm
 */
export interface CreatePromotionLeadForm {
    /**
     *
     * @type {string}
     * @memberof CreatePromotionLeadForm
     */
    promotionId: string;
    /**
     *
     * @type {string}
     * @memberof CreatePromotionLeadForm
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof CreatePromotionLeadForm
     */
    phone: string;
    /**
     *
     * @type {string}
     * @memberof CreatePromotionLeadForm
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof CreatePromotionLeadForm
     */
    recaptcha: string;
}

export function CreatePromotionLeadFormFromJSON(json: any): CreatePromotionLeadForm {
    return CreatePromotionLeadFormFromJSONTyped(json, false);
}

export function CreatePromotionLeadFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromotionLeadForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'promotionId': json['promotionId'],
        'name': json['name'],
        'phone': json['phone'],
        'email': json['email'],
        'recaptcha': json['recaptcha'],
    };
}

export function CreatePromotionLeadFormToJSON(value?: CreatePromotionLeadForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'promotionId': value.promotionId,
        'name': value.name,
        'phone': value.phone,
        'email': value.email,
        'recaptcha': value.recaptcha,
    };
}
